module.exports = __webpack_public_path__ + "static/Global2-07d75590c372f0e709325808c91a49c6.png";